import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Building2Icon, ChevronDownIcon, HomeIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { requestMarket } from '../utils/market';
import type { NavItem } from '../types/content';
export function ServicesMenu({
  item
}: {
  item: NavItem;
}) {
  const {
    t
  } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLLIElement>(null);
  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);
  return <li ref={ref} className="relative" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} data-id="element-313" data-mp="3fa7pvxwcju0j">
      <button type="button" aria-expanded={open} aria-controls="services-menu" onClick={() => setOpen(o => !o)} className="flex items-center gap-1 whitespace-nowrap rounded-md px-2.5 py-2 text-[14px] font-medium text-navy-soft transition-colors duration-150 hover:bg-white/10 hover:text-white" data-id="element-314" data-mp="3af23yz2y2fcg">
        {t(item.label)}
        <ChevronDownIcon className={`h-4 w-4 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-315" data-mp="2rnstonlcnmjt" />
      </button>
      <AnimatePresence data-id="element-316" data-mp="36d731voxe3z7">
        {open && <motion.div id="services-menu" initial={{
        opacity: 0,
        y: -4,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -4,
        scale: 0.98
      }} transition={{
        duration: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute left-0 top-full origin-top-left pt-2" data-id="element-317" data-mp="31jmeeu982mco">
            <ul className="w-72 rounded-xl bg-white p-2 shadow-xl ring-1 ring-black/5" data-id="element-318" data-mp="32lhboctz4x5z">
              {item.children?.map(c => {
            const Icon = c.market === 'commercial' ? Building2Icon : HomeIcon;
            return <li key={c.href} data-id="element-319" data-mp="3cb0uxjllmt1d">
                    <a href={c.href} onClick={() => {
                requestMarket(c.market);
                setOpen(false);
              }} className="flex items-start gap-3 rounded-lg px-3 py-2.5 transition-colors duration-150 hover:bg-mist focus-visible:bg-mist focus-visible:outline-none" data-id="element-320" data-mp="2fl9nykw4fdeo">
                      <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-leaf-wash text-leaf-deep" data-id="element-321" data-mp="3vza0fkv7fal">
                        <Icon className="h-4 w-4" aria-hidden="true" data-id="element-322" data-mp="8tqx8waked8g" />
                      </span>
                      <span data-id="element-323" data-mp="1tbt87aavtm5a">
                        <span className="block font-semibold text-ink" data-id="element-324" data-mp="1texhgm37f82t">{t(c.label)}</span>
                        <span className="block text-sm text-muted" data-id="element-325" data-mp="1oejjjwvbheii">{t(c.description)}</span>
                      </span>
                    </a>
                  </li>;
          })}
            </ul>
          </motion.div>}
      </AnimatePresence>
    </li>;
}